import { motion } from "framer-motion";
import { Sparkles, CalendarHeart, Layers, Hand, HeartHandshake } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { SERVICES } from "@/lib/site";

const ICONS = { Sparkles, CalendarHeart, Layers, Hand, HeartHandshake };

export const Services = () => {
  return (
    <section id="services" className="relative py-24 sm:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <Reveal className="mb-14 max-w-2xl">
          <p className="mb-3 text-xs uppercase tracking-[0.25em] text-[#F0C674]/80">
            Глава 01 — Что можно узнать
          </p>
          <h2 className="font-serif text-4xl font-bold text-[#EDE6D3] sm:text-5xl lg:text-6xl">
            Что можно <span className="text-gold-gradient">разобрать</span>
          </h2>
          <p className="mt-4 text-[#EDE6D3]/60">
            Пять направлений разбора — выбирайте то, что откликается именно вам.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.title} delay={i * 0.08}>
                <motion.article
                  whileHover={{ y: -8 }}
                  transition={{ type: "spring", stiffness: 300, damping: 20 }}
                  className="group relative h-full overflow-hidden rounded-2xl border border-[#D4AF6E]/12 bg-surface p-7 transition-shadow duration-300 hover:shadow-[0_0_40px_rgba(91,58,120,0.45)]"
                  data-testid={`service-card-${i}`}
                >
                  <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-[#5B3A78]/0 blur-2xl transition-all duration-500 group-hover:bg-[#5B3A78]/40" />
                  <span className="relative flex h-12 w-12 items-center justify-center rounded-xl border border-[#D4AF6E]/25 bg-[#0B0B1F] p-3">
                    <Icon className="h-6 w-6 text-[#F0C674]" />
                  </span>
                  <h3 className="relative mt-5 font-serif text-2xl font-semibold text-[#EDE6D3]">
                    {s.title}
                  </h3>
                  <p className="relative mt-2 text-sm leading-relaxed text-[#EDE6D3]/60">
                    {s.text}
                  </p>
                </motion.article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
